// Curated vehicle catalog: make -> [models], category-aware.
//
// Drives the Make + Model datalists on Vehicles/Form.vue. HTML5 <datalist>
// is type-and-autocomplete, so any value the operator types is accepted —
// these lists are suggestions, not validation. Adding entries is cheap.

export const TWO_WHEELER_CATALOG = {
  Honda:    [ 'PCX 160', 'PCX 125', 'Click 125i', 'Click 160', 'ADV 160', 'Scoopy', 'Wave 125i', 'CB 150R', 'CBR 150R', 'CBR 500R', 'CB 500X', 'Forza 350', 'Forza 750', 'Rebel 500', 'Rebel 1100' ],
  Yamaha:   [ 'NMAX 155', 'XMAX 300', 'Aerox 155', 'Grand Filano', 'Fino 125', 'Tricity 155', 'TMAX 560', 'MT-03', 'MT-07', 'MT-09', 'R3', 'R6', 'R1', 'Tenere 700', 'WR155R' ],
  Suzuki:   [ 'Burgman Street', 'Address 110', 'Avenis 125', 'GSX-R 150', 'GSX-S 150', 'V-Strom 250', 'V-Strom 650', 'V-Strom 1050', 'Hayabusa' ],
  Kawasaki: [ 'Ninja 400', 'Ninja 650', 'Ninja H2', 'Z400', 'Z650', 'Z900', 'Versys 650', 'Versys 1000', 'KLX 150', 'KLX 230', 'KLX 300', 'Vulcan S', 'W175' ],
  Vespa:    [ 'Primavera 150', 'Sprint 150', 'GTS 300', 'GTV 300', 'Elettrica' ],
  Piaggio:  [ 'Liberty 150', 'Medley 150', 'Beverly 300', 'MP3 300', 'MP3 500' ],
  Royal_Enfield: [ 'Hunter 350', 'Classic 350', 'Meteor 350', 'Bullet 350', 'Continental GT 650', 'Interceptor 650', 'Himalayan 411', 'Himalayan 450', 'Super Meteor 650' ],
  BMW:      [ 'C 400 X', 'C 400 GT', 'CE 04', 'G 310 R', 'F 850 GS', 'R 1250 GS', 'S 1000 RR' ],
  Ducati:   [ 'Scrambler 800', 'Monster 821', 'Panigale V2', 'Panigale V4', 'Multistrada V4', 'Diavel V4' ],
  KTM:      [ 'Duke 200', 'Duke 390', 'RC 390', 'Adventure 250', 'Adventure 390', '790 Duke' ],
  Harley_Davidson: [ 'Iron 883', 'Fat Boy', 'Street Glide', 'Sportster S', 'Pan America 1250' ],
  GPX:      [ 'Demon 150 GR', 'Drone 150', 'Legend 150', 'Razer 220', 'Gentleman 200' ],
  CFMoto:   [ '300NK', '650NK', '650MT', '700CL-X', '800MT' ],
}

export const FOUR_WHEELER_CATALOG = {
  Toyota:   [ 'Yaris', 'Yaris Ativ', 'Vios', 'Corolla Altis', 'Camry', 'Fortuner', 'Hilux Revo', 'Innova', 'Sienta', 'C-HR', 'bZ4X', 'Hiace', 'Commuter', 'Veloz' ],
  Honda:    [ 'City', 'Civic', 'Accord', 'CR-V', 'HR-V', 'BR-V', 'WR-V', 'Jazz' ],
  Mazda:    [ 'Mazda2', 'Mazda3', 'CX-3', 'CX-30', 'CX-5', 'CX-8', 'CX-9', 'BT-50' ],
  Mitsubishi: [ 'Mirage', 'Attrage', 'Xpander', 'Xpander Cross', 'Pajero Sport', 'Triton', 'Outlander PHEV' ],
  Nissan:   [ 'Almera', 'Note', 'March', 'Kicks e-POWER', 'Terra', 'Navara', 'Leaf' ],
  Isuzu:    [ 'D-Max', 'MU-X' ],
  Ford:     [ 'Ranger', 'Everest', 'Raptor', 'Territory' ],
  Suzuki:   [ 'Swift', 'Ciaz', 'Ertiga', 'XL7', 'Jimny' ],
  Hyundai:  [ 'Stargazer', 'Creta', 'H-1', 'Ioniq 5', 'Ioniq 6', 'Tucson' ],
  Kia:      [ 'Picanto', 'Soluto', 'Sportage', 'Sorento', 'Carnival', 'EV6' ],
  Volkswagen: [ 'Polo', 'Golf', 'Tiguan', 'Touareg', 'ID.4' ],
  BMW:      [ '320d', '330e', 'X1', 'X3', 'X5', '5 Series', 'iX3', 'i4' ],
  Mercedes: [ 'A-Class', 'C-Class', 'E-Class', 'S-Class', 'GLA', 'GLC', 'GLE', 'EQS' ],
  Audi:     [ 'A3', 'A4', 'A6', 'Q3', 'Q5', 'Q7', 'e-tron GT' ],
  Tesla:    [ 'Model 3', 'Model Y', 'Model S', 'Model X' ],
  BYD:      [ 'Atto 3', 'Dolphin', 'Seal', 'Sealion 6', 'M6', 'Han', 'Tang' ],
  MG:       [ 'MG3', 'MG5', 'ZS EV', 'HS', 'Maxus 9', 'Cyberster' ],
  Subaru:   [ 'Forester', 'Outback', 'XV', 'BRZ', 'WRX' ],
  Lexus:    [ 'IS', 'ES', 'NX', 'RX', 'LX', 'LS', 'RZ' ],
  Renault:  [ 'Kwid', 'Kiger', 'Triber', 'Megane E-Tech' ],
  Volvo:    [ 'XC40', 'XC60', 'XC90', 'EX30', 'EX90' ],
}

// Two-wheeler categories share one catalog; four-wheeler categories share
// another. Lookup is by vehicle_class.
export function makesFor(vehicleClass) {
  const map = vehicleClass === 'four_wheeler' ? FOUR_WHEELER_CATALOG : TWO_WHEELER_CATALOG
  return Object.keys(map).map(k => k.replace(/_/g, ' '))
}

export function modelsFor(vehicleClass, make) {
  if (!make) return []
  const map = vehicleClass === 'four_wheeler' ? FOUR_WHEELER_CATALOG : TWO_WHEELER_CATALOG
  // Case-insensitive lookup; allow the user-typed make to match a key
  // regardless of underscore-vs-space.
  const key = Object.keys(map).find(k => k.replace(/_/g, ' ').toLowerCase() === make.toLowerCase())
  return key ? map[key] : []
}

// Extract engine displacement (cc) from a model name. Most motorcycle models
// embed the CC: "NMAX 155", "PCX 160", "CBR 500R", "Z900", "Pan America 1250".
// Limit to 50–1800cc to avoid matching trim/variant numbers ("MT-09" -> 09,
// "X5" -> 5) and to skip irrelevant numerics on car models that happen to
// fall in the range. Returns null when no plausible CC is found.
export function extractCC(model) {
  if (!model) return null
  const matches = String(model).matchAll(/\d+/g)
  for (const m of matches) {
    const n = parseInt(m[0], 10)
    if (n >= 50 && n <= 1800) return n
  }
  return null
}
